module.exports = __webpack_public_path__ + "img/painpointHeart.e48d8532.svg";